// DS5.1
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook, ReferralType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Url, URLS } from '@wix/da-url';
import Logo from '../_partials/LogoWithCoreLevel';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData } from '@wix/da-bi/pkg/events';
import DealerAd from '../../DealerAd';
import ErrorBoundary from '../../ErrorBoundary';
import HeaderSearchInput from '../_partials/HeaderSearchInput';
import Burger from '../_partials/Burger';
import CartIconButton from '../_partials/CartIconButton';
import MoreMenu from '../_partials/MoreMenu';
import WatchButton from '../_partials/WatchButton';
import { useCurrentPromo } from '../../utils/hooks/useCurrentPromo';
import SubmitMenu from '../_partials/SubmitMenu';
import UserDropdownMenu from '../_partials/UserDropdownMenu';
import ChatButtonAndDropdown from '../_partials/ChatButtonAndDropdown';
import NotificationsDropdownWrapper from '../_partials/NotificationsDropdownWrapper';
import s from './SiteHeaderDesktop.scss';
const DEALER_PROD_REALESTATEID = '9c14ea7a-8c35-429a-9857-00ad04ebb4c1';
const SiteHeader = ({ searchQuery, searchBasePath, hasCoreMembership, isLoggedIn, isLegacyHeader, showNetworkBar = true, cartCount, canSeeOldWatch })=>{
    const { t } = useTranslation();
    const daBirthday23 = useFlag('dabirthday_23');
    const logoUrl = Url.buildFromPath(URLS.ROOT);
    const currentPromo = useCurrentPromo('self');
    const canSeeWatchButton = isLoggedIn && canSeeOldWatch;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SiteHeaderDesktop"
    }, /*#__PURE__*/ React.createElement("header", {
        role: "banner",
        "data-hook": BiDataHook.TOP_NAV,
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Burger, {
        showNetworkBar: showNetworkBar,
        iconClassName: s['icon']
    }), /*#__PURE__*/ React.createElement(BiLink, {
        biData: BiData({
            evid: 700,
            link_url: logoUrl,
            link_name: 'logo'
        }),
        href: daBirthday23 ? undefined : logoUrl,
        onClick: daBirthday23 ? ()=>{
            window.location.assign(logoUrl);
        } : undefined,
        "aria-label": t('siteHeader.a11y.home'),
        className: s['logo-link']
    }, /*#__PURE__*/ React.createElement(Logo, {
        size: "tiny",
        className: s['logo'],
        markColorClassname: s['logo-mark'],
        textColorClassname: s['logo-text'],
        coreClassName: s['logo-core'],
        withBalloon: daBirthday23
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), canSeeWatchButton && /*#__PURE__*/ React.createElement(WatchButton, {
        className: c(s['text-button'], s['regular-text-button'])
    }), /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: c(s['text-button'], s['regular-text-button']),
        href: Url.shopLink(),
        biData: BiData({
            evid: 700,
            link_url: Url.shopLink(),
            link_name: 'shop'
        })
    }, t('siteHeader.shop')), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), isLoggedIn && /*#__PURE__*/ React.createElement(NotificationsDropdownWrapper, {
        className: c(s['icon-button'], s['icon-button-has-submenu']),
        iconClassName: s['icon'],
        numberClassName: s['number'],
        isLegacyHeader: isLegacyHeader
    }), /*#__PURE__*/ React.createElement(HeaderSearchInput, {
        className: s['search-input'],
        searchQuery: searchQuery,
        searchBasePath: searchBasePath
    }), !hasCoreMembership && /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: 'core-orange',
        className: c(s['text-button'], s['upgrade-to-core'], isLoggedIn && s['upgrade-to-core-loggedin']),
        href: URLS.CORE_MEMBERSHIP,
        biData: BiData({
            evid: 375,
            referral_info: ReferralType.HEADER
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['long-copy']
    }, t('siteHeader.upgradeToCore')), /*#__PURE__*/ React.createElement("span", {
        className: s['short-copy']
    }, t('common.getCore'))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        realEstateId: DEALER_PROD_REALESTATEID,
        className: s['ad-slot']
    }), !isLoggedIn && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "main",
        biData: {
            evid: BiEventType.REDIRECT_TO_LOGIN,
            referral_info: ReferralType.HEADER
        },
        className: s['text-button'],
        href: Url.joinLink()
    }, t('siteHeader.join')), /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "main",
        biData: BiData({
            evid: 700,
            link_url: Url.loginLink(),
            link_name: 'login'
        }),
        className: s['text-button'],
        href: Url.loginLink()
    }, t('siteHeader.signIn'))), /*#__PURE__*/ React.createElement(MoreMenu, {
        isLoggedIn: !!isLoggedIn,
        className: c(s['icon-button'], s['more-menu-button']),
        menuClassName: s['more-menu']
    }), isLoggedIn && /*#__PURE__*/ React.createElement(ChatButtonAndDropdown, {
        className: c(s['icon-button'], s['icon-button-has-submenu']),
        iconClassName: s['icon'],
        numberClassName: s['number'],
        disableDropdown: isLegacyHeader
    }), cartCount > 0 && /*#__PURE__*/ React.createElement(CartIconButton, {
        className: s['icon-button'],
        cartCount: cartCount,
        iconClassName: s['icon'],
        numberClassName: s['number']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['user-icon-button-wrapper']
    }, /*#__PURE__*/ React.createElement(UserDropdownMenu, {
        isOpen: false,
        className: s['icon-submenu'],
        disableThemeSwitcher: false,
        isLegacyHeader: isLegacyHeader,
        currentPromo: currentPromo
    })), /*#__PURE__*/ React.createElement(SubmitMenu, {
        isOpen: false,
        className: c(s['icon-button-has-submenu'], s['icon-button-has-submit-submenu']),
        menuClassName: s['icon-submenu'],
        isLegacyHeader: isLegacyHeader
    }))));
};
SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;
